// CollectionProductPageWrapper.jsx
import React from "react";
import { useParams } from "react-router-dom";
import CollectionProductPageDynamic from "../CollectionProductPageDynamic";
import CollectionSubCategiesPage from "../../../../pages/collectionSubCategoriesPage";

const CollectionProductPageWrapper = () => {
  const { collectionName } = useParams();

  if (collectionName === "Binny's Select Designs") {
    return <CollectionSubCategiesPage />;
  }

  return <CollectionProductPageDynamic />;
};

export default CollectionProductPageWrapper;
